import React from 'react';

export default function asFullScreen(Component) {
  return class FullScreen extends React.PureComponent {
    constructor(props) {
      super(props);
      this.onRouteChange = this.onRouteChange.bind(this);
      this.url           = null;
    }

    componentDidMount() {
      this.$f7ready(f7 => {
        f7.views.main.router.on('routeChange', this.onRouteChange);
      });
    }

    componentWillUnmount() {
      this.$f7ready(f7 => {
        f7.views.main.router.off('routeChange', this.onRouteChange);
      });
    }

    onRouteChange(route) {
      if (this.url === route.path || !this.url) {
        this.hideSideBar();
        this.goToFullWidth();
      } else
        this.hideFullScreen();
      this.url = route.path;
    }

    hideFullScreen() {
      this.url = null;
      this.goToNormalWidth();
      this.showSideBar();
    }

    hideSideBar() {
      document.querySelector('.panel-left').style.display = 'none';
    }

    showSideBar() {
      document.querySelector('.panel-left').style.display = 'block';
    }

    goToFullWidth() {
      document.querySelector('.views').style.paddingLeft  = 0;
      document.querySelector('.view-main').style.position = 'static';
    }

    goToNormalWidth() {
      document.querySelector('.views').style.removeProperty('padding-left');
      document.querySelector('.view-main').style.position = 'relative';
    }

    render() {
      return <Component {...this.props}/>;
    }
  };
}
